import { Alert } from "@interstate/components/Alert";
import { StyledContainerAlert } from "./styled";

export interface RepairOrderPriorityAlertProps {
  autoLeadId: string | null;
  repairOrderId: string | null;
}

export function RepairOrderPriorityAlert({
  autoLeadId,
  repairOrderId
}: RepairOrderPriorityAlertProps) {
  if (!autoLeadId || !repairOrderId) {
    return null;
  }

  return (
    <StyledContainerAlert>
      <Alert
        id="RepairOrderPriorityWarning"
        role="info"
        title="ID Priority"
        type="info"
      >
        Both Lead ID and Repair Order ID provided. Lead ID will be prioritized.
      </Alert>
    </StyledContainerAlert>
  );
}
